import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { FocusSDK } from "@/utils";
import bus from "@/utils/bus";
import { isLogin } from "@/utils/user";
import { throttle } from "lodash";
import React, { memo, useState, useEffect, useContext, useCallback, useRef } from "react";
const posLimit = {
  x: 12,
  y: 12,
  width: 64,
  height: 64
};
const AI = memo(() => {
  const { authInfo, appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const posRef = useRef<{
    left: number;
    top: number;
  } | null>(null);
  const [posStyle, setPosStyle] = useState<{
    left?: number;
    top?: number;
    bottom?: number;
    right?: number;
  } | null>({
    right: 16
  });
  // 打开京小助
  const openAIAssistant = useCallback(() => {
    if (!isLogin(appRuntimeEnv)) {
      FocusSDK.emit("showLogin", {
        type: "openHomeAI",
        content: {}
      });
      return;
    }
    let url = appRuntimeEnv.meMainEntry + "/jqqAiChat#/home";
    // const q = encodeURIComponent(question);
    // const baseUrl = this.baseService.appRuntimeEnv.meMainEntry;
    // const host = new URL(baseUrl).origin;

    url =
      url +
      `?appSource=jd&token=${authInfo.accessToken}&lat=&lng=&cityCode=&cityName=&fromType=jqt`;
    FocusSDK.launchJQTAssistantWindow({
      url,
      teamId: authInfo.selectedTeamId || "",
      token: authInfo.accessToken,
      question: ""
    });
  }, [authInfo, appRuntimeEnv]);

  useEffect(() => {
    bus.on("openHomeAI", openAIAssistant);
    return () => {
      bus.off("openHomeAI", openAIAssistant);
    };
  }, [openAIAssistant]);
  const onDragEnd = (e: any) => {
    const nodeRect = getContainer()?.getBoundingClientRect();
    if (!nodeRect) return;
    let x = e.pageX;
    let y = e.pageY;
    if (nodeRect.x + posLimit.x > x) {
      x = nodeRect.x + posLimit.x;
    }
    if (nodeRect.x + nodeRect.width - posLimit.width - posLimit.x < x) {
      x = nodeRect.x + nodeRect.width - posLimit.width - posLimit.x;
    }
    if (nodeRect.y + posLimit.y > y) {
      y = nodeRect.y + posLimit.y;
    }
    if (nodeRect.y + nodeRect.height - posLimit.height - posLimit.y < y) {
      y = nodeRect.y + nodeRect.height - posLimit.height - posLimit.y;
    }
    posRef.current = {
      left: x,
      top: y
    };
    setPosStyle({
      // left: x,
      right: 18,
      top: y
    });
  };
  const handleResize = throttle(() => {
    const nodeRect = getContainer()?.getBoundingClientRect();
    if (!nodeRect || !posRef.current) return;
    let x = posRef.current.left;
    let y = posRef.current.top;
    // if (nodeRect.x + nodeRect.width - posLimit.width - posLimit.x < x) {
    //   x = nodeRect.x + nodeRect.width - posLimit.width - posLimit.x;
    // }
    if (nodeRect.y + nodeRect.height - posLimit.height - posLimit.y < y) {
      y = nodeRect.y + nodeRect.height - posLimit.height - posLimit.y;
    }
    setPosStyle({
      // left: x,
      right: 18,
      top: y
    });
  }, 200);
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);
  const onDragStart = (e: any) => {
    const node = getContainer();
    if (!node) return;
    e.dataTransfer.dropEffect = "move";
    e.dataTransfer.effectAllowed = "move";
  };
  const onDragDrop = (e: any) => {
    console.log(e, "onDragDrop");
  };
  const onDragOver = (e: any) => {
    e.preventDefault();
  };
  const getContainer = () => {
    const node: any = document.getElementsByClassName("home-page")?.[0];
    return node;
  };
  useEffect(() => {
    const node = getContainer();
    if (!node) {
      return;
    }
    node.addEventListener("dragover", onDragOver);
    node.addEventListener("drop", onDragDrop);
    return () => {
      node.removeEventListener("dragover", onDragOver);
      node.removeEventListener("drop", onDragDrop);
    };
  }, [onDragDrop, onDragOver]);

  return (
    <div
      style={posStyle ? posStyle : {}}
      draggable
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      className="home-AI"
      id="home-AI"
      onClick={(e) => {
        e.stopPropagation();
        openAIAssistant();
      }}
    />
  );
});

export default AI;
